"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var grid_1 = require("./grid");
var icons_1 = require("../icons");
var layout_1 = require("../util/layout");
var components = {
    back: icons_1.ArrowBack,
    left: icons_1.ArrowLeft,
    right: icons_1.ArrowRight,
    close: icons_1.Close,
    menu: icons_1.Menu,
};
var ClickTarget = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  appearance: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n\n  min-height: ", ";\n  min-width: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: transparent;\n\n  &:active {\n    background-color: ", ";\n  }\n\n  // hack: only apply hover rule on non-mobile viewport\n  @media (min-width: ", "px) {\n    &:hover {\n      background - color: ", ";\n    }\n  }\n"], ["\n  appearance: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n\n  min-height: ", ";\n  min-width: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: transparent;\n\n  &:active {\n    background-color: ", ";\n  }\n\n  // hack: only apply hover rule on non-mobile viewport\n  @media (min-width: ", "px) {\n    &:hover {\n      background - color: ", ";\n    }\n  }\n"])), (0, layout_1.space)(4), (0, layout_1.space)(4), function (_a) {
    var theme = _a.theme, bgColor = _a.bgColor;
    return bgColor ? (0, polished_1.darken)(0.1, bgColor) : theme.colors.grayBorder;
}, (0, layout_1.breakPoint)('md'), function (_a) {
    var theme = _a.theme, bgColor = _a.bgColor;
    return bgColor ? (0, polished_1.darken)(0.1, bgColor) : theme.colors.grayBorder;
});
var IconButton = function (_a) {
    var noButton = _a.noButton, icon = _a.icon, children = _a.children, rest = __rest(_a, ["noButton", "icon", "children"]);
    var Component = icon ? components[icon] : null;
    return (react_1.default.createElement(ClickTarget, __assign({}, rest, (noButton && { as: 'span' })),
        react_1.default.createElement(grid_1.Container, { center: true }, Component ? react_1.default.createElement(Component, null) : children)));
};
exports.default = IconButton;
var templateObject_1;
//# sourceMappingURL=IconButton.js.map